<template>
    <el-table
      :data="dataList"
      size="mini"
      empty-text="暂无数据"
      :height="tabHeight"
      @row-contextmenu="rowContextmenu"
      style="width: 100%">
      <!-- <el-table-column
        label="移动目录"
        align="center"
        width="70">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="drag-edit">
            <i class="drag-edit" title="可拖拽放置指定的目录中"><svg-drag :width="18" :height="18" fill="#606266"></svg-drag></i>
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column
        label="序号"
        align="center"
        width="50px"
        type="index">
      </el-table-column>
      <el-table-column label="设备logo" width="120px">
        <template slot-scope="scope">
          <prod-icon :src="scope.row.equipmentImages[0].FileServerPath" width="50"></prod-icon>
        </template>
      </el-table-column>
      <el-table-column label="设备名称" prop="CompName" :min-width="120">
        <template slot-scope="scope">
          <span style="font-size: 14px;">{{ scope.row.equipmentName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分类" prop="cName" :min-width="120"></el-table-column>
      <el-table-column label="工时费" prop="manHour" :min-width="80"></el-table-column>
      <el-table-column label="浏览次数" prop="viewNums" :min-width="80"></el-table-column>
      <el-table-column label="创建时间" prop="createDate" :min-width="150"></el-table-column>
    </el-table>
</template>

<script>
import { OpenService } from '@/service'

import ProdIcon from "@/components/icon/prod-icon";
import SvgDrag from '@/components/svg/drag.vue';

export default {
  props: {
    dataList: { default: [] },
    isCanEdit: { default: true }
  },
  data() {
    return {
      tabHeight: document.body.clientHeight - 20 - 43
    }
  },
  mounted() {
    window.onresize = () => {
      this.tabHeight = document.body.clientHeight - 20 - 43
    }
  },
  components: { ProdIcon, SvgDrag },
  methods: {
    goDetail(row) {
      OpenService.openCompDetail(row.CompID);
    },
    edit(row) {
      this.$emit('remarkEdit', row);
    },
    del(row) {
      this.$emit('del', row);
    },
    rowContextmenu(row, column, event) {
      this.$emit('rowContextmenu', row, event);
    }
  }
}
</script>


<style lang="less" scoped>
/deep/ .el-table__cell {
  text-align: center;
  font-size: 14px;
}
</style>
